import React, { useState } from "react"
import GetQuoteForm from "../components/GetQuoteForm"
import MainLayout from "../layouts/MainLayout"
import { Heading1 } from "../components/utils/Typography"
import Breadcrumb from "../components/utils/Breadcrumb"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import "../styles/global.scss"

function GetQuote() {
  const [toastObj, setToastObj] = useState(null)

  return (
    <div className="services">
      <MainLayout>
        <Breadcrumb
          arr={[
            { name: "Home", path: "/" },
            { name: "Get Qoute", path: "/getQuote" },
          ]}
        />
        <Heading1
          heading="Get Quote"
          subheading="right pricing plan, for right project"
        />
        <div className="container my-4">
          <div className="d-flex justify-content-center align-items-center">
            <div className="fs-5 text-center" style={{ maxWidth: "992px" }}>
              Do you have a project idea and want us to build it using latest
              technologies that provide you high speed and reliable uptime? Get
              in touch with us to get your Project Quote for FREE <br /> <br />
              <b>
                <a
                  href="mailto:
            info@codefumes.com"
                  className="text-purple"
                >
                  info@codefumes.com
                </a>
              </b>
              {/* <small>
                (Note: For general queries, use{" "}
                <AniLink
                  paintDrip
                  hex="#551864"
                  to="/#letsTalk"
                  className="my-1 text-purple"
                >
                  this form
                </AniLink>
                )
              </small>
              <br />
              <small>Use buttons below to navigate through the form</small> */}
            </div>
          </div>
          {/* <GetQuoteForm setToastObj={setToastObj} /> */}
        </div>

        {/* toast alert */}
        {toastObj && (
          <div
            className="toast myToastBottomLeft"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="toast-header">
              <img
                src="favicon.ico"
                className="rounded me-2"
                alt="toast-logo"
                width="22px"
              />
              <strong className="me-auto">{toastObj.heading}</strong>
              <small>{toastObj.timePassed}</small>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="toast"
                aria-label="Close"
                onClick={setToastObj(null)}
              ></button>
            </div>
            <div className="toast-body">{toastObj.desc}</div>
          </div>
        )}
      </MainLayout>
    </div>
  )
}

export default GetQuote
